import { Component, OnInit } from '@angular/core';
import { IBudgetHeader, IBudgetDetail } from '../../budget/new-budget/new-budget.component';
import { BudgetService } from '../../services/budget.service';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { CxcService } from '../../services/cxc.service';
import { ListofvaluesService } from '../../services/listofvalues.service';
import { BillingService } from '../../services/billing.service';
import { NotifierService } from '../../../system/shared/notifier/notifier.service';
import { InternalService } from '../../services/internal.service';
import { MatDialog } from '@angular/material';
import { DiscountModalComponent } from './modal/discountModal.component';
import { AssignDiscountModalComponent } from './modal/assignDiscountModal.component';
import { Subscription } from 'rxjs/Subscription';
import { AppService } from './app.service';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-new-billing',
  templateUrl: 'new-billing.component.html',
  styleUrls: ['new-billing.component.scss'],
  providers: [BudgetService, CxcService, ListofvaluesService, BillingService]

})
export class NewBillingComponent implements OnInit {
  budgetHeaderData: IBudgetHeader;
  budgetDetailData: Array<IBudgetDetail>;
  budgetId: number;
  percentageAmount = [];
  generaLines = 0;
  ratioDSCTO : any  = "1";
  codigo_sunat = [];
  totalAmount = [];
  appliedDiscount= [];
  totalDescAmount = [];
  totalBill = 0;
  codigosSunatList = [];
  totalLines = 0;
  totalDiscount = 0;
  IGV = 0.18;
  tax_type = 1;
  totalTax = 0;
  billingId: any;
  ldvMoney: any;
  currencyMoney = '';
  typeBilling: any;
  typeBillingPronos: any;
  titleBilling: any = "";
  typeNote: any;
  typeNoteCreditPronos: any;
  typeNoteDebitPronos: any;
  subscription: Subscription;
  discountData = [];
  public discounts: any[];
  linesDiscount: any[] = [];
  negativeLines:any = [];
  billId:any;

  constructor(private budgetService: BudgetService,
    private cxcpaymentService: CxcService,
    private listofvaluesService: ListofvaluesService,
    private billingService: BillingService,
    private internalService: InternalService,
    private route: ActivatedRoute,
    private notifierService: NotifierService,
    private dialog: MatDialog,
    private appService: AppService) {
      this.discounts = [];
      /*this.listofvaluesService.getCodigoSunat().subscribe((mon) => {
        this.ldvMoney = mon;
        this.ldvMoney.forEach(element => {
          // tslint:disable-next-line:triple-equals
          if (element.id == this.budgetHeaderData.currency) {
            this.currencyMoney = element.ref1;
          }
        });
      });*/
    this.route.params.subscribe((params) => {
      if (params['budid']) {
        this.budgetId = params['budid'];
        this.typeBilling = params['type'].split("-")[0];
        if(params['type'].split("-").length > 0){
          this.typeNote = params['type'].split("-")[1];
        }
        if(params['bill']){
          console.log("bill recive",params['bill']);
          this.billId=params['bill'];
          console.log("bill id",this.billId);
        }
        switch(this.typeBilling){
          case "F":
            this.titleBilling="Factura";
            this.typeBillingPronos = 1;
            break;
          case "B":
            this.titleBilling="Boleta";
            this.typeBillingPronos = 2;
            break;
          case "NC":
            this.titleBilling="Nota de Crédito";
            this.typeBillingPronos = 3;
            if(this.typeNote)
              this.typeNoteCreditPronos = this.typeNote;
            break;
          case "ND":
            this.titleBilling="Nota de Débito";
            this.typeBillingPronos = 4;
            if(this.typeNote)
              this.typeNoteDebitPronos = this.typeNote;
            break;
        /*  case "GR":
            this.titleBilling="Guia de Remisión";
            this.typeBillingPronos = "B";
            break; */
        }
        this.budgetService.getOneBudget(this.budgetId).subscribe((result) => {
          
          
          this.budgetHeaderData = result;
          this.tax_type = this.budgetHeaderData.tax;
          this.listofvaluesService.getLdvByCode('TBWA-MONEY').subscribe((mon) => {
            this.ldvMoney = mon;
            this.ldvMoney.forEach(element => {
              // tslint:disable-next-line:triple-equals
              if (element.id == this.budgetHeaderData.currency) {
                this.currencyMoney = element.ref1;
              }
            });
          });
          this.getTable();
          //SET GLOBAL
          this.addGlobalDiscount( this.budgetHeaderData.discount_global);
        });
      }
    });
  }

  getTable() {

    if(this.typeBilling=="ND" || this.typeBilling=="NC"){
      this.budgetService.getBudgetDetailsFactForNotes(this.budgetId).subscribe((listBudgetDetails: Array<IBudgetDetail>) => {
        this.budgetDetailData = listBudgetDetails;

        this.budgetDetailData.forEach((item: any, index) => {
          item.selected = false;
          item.price = item.price_total;
          this.percentageAmount.push(0);
          this.totalAmount.push(item.price * this.percentageAmount[index] / 100);
          this.totalDescAmount.push(item.price * this.percentageAmount[index] / 100);
        });
      });
    }else{
      this.budgetService.getBudgetDetailsNoFact(this.budgetId).subscribe((listBudgetDetails: Array<IBudgetDetail>) => {
        this.budgetDetailData = listBudgetDetails;
        
        this.budgetDetailData.forEach((item: any, index) => {
          item.selected = false;
          item.price = item.price_total - item.price_invoiced;
          
         /* if (item.discount_type &&  item.discount_type != 1 && item.discount_amount){
            this.percentageAmount.push(100);
            this.totalAmount.push(item.price * this.percentageAmount[index] / 100);
            this.totalDescAmount.push(item.price * this.percentageAmount[index] / 100);

            var tipo  = 0
            if (item.discount_type == 2){
              tipo = 2;
            } else  if(item.discount_type == 3){
              tipo  = 1;
            }
            
            if(this.validateDiscount(index, item.discount_amount,tipo)){
              var objDisc = {
                  details: 'Descuento Presupuesto',
                  value: item.discount_amount, 
                  type: tipo , 
                  lineSelect: index};
              this.discounts.push(objDisc);
              this.updateDiscount();
            }
          }else{*/
            this.percentageAmount.push(0);
            this.totalAmount.push(item.price * this.percentageAmount[index] / 100);
            this.totalDescAmount.push(item.price * this.percentageAmount[index] / 100);

         /* }*/
        });
      });
    }
  }

  updateCalc(index: number) {
    
    if (this.typeBilling =='NC'){
      this.generaLines = 0;
      var currentSelected = 0;
      this.budgetDetailData.forEach((item, _index) => {
        const detailProd: any =item;
        this.generaLines = this.generaLines + detailProd.price_total;
     
      });
    }else{
      this.generaLines = this.budgetHeaderData.facturado;
      var currentSelected = 0;
      this.budgetDetailData.forEach((item, _index) => {
        const detailProd: any =item;
        this.generaLines = this.generaLines + detailProd.price_total;
     
      });

    }

   

    

    if (this.percentageAmount[index] > 100 || this.percentageAmount[index] < 0) {

      this.percentageAmount[index] = 0;
    }
    this.totalAmount[index] = this.budgetDetailData[index].price_full * this.percentageAmount[index] / 100;
    console.log(' this.totalAmount[index] ', this.totalAmount[index] )
    this.totalDescAmount[index] = this.budgetDetailData[index].price_total * this.percentageAmount[index] / 100;
    console.log(' this.totalDescAmount[index] ', this.totalDescAmount[index] )
    this.appliedDiscount[index] = this.totalAmount[index]-  this.totalDescAmount[index] ;

    this.totalLines = 0;
    let Tax = 0;
    this.totalAmount.forEach((item, _index) => {
      if(item>=0)
        this.totalLines += item;
        Tax += Number((item*this.IGV).toFixed(2))

        console.log('OTEMS', item)
    });
    var totalLineas = 0;
    this.totalDescAmount.forEach((item, _index) => {
      if(item>=0)
        totalLineas += item;
    });

    
    // tslint:disable-next-line:triple-equals
    if (this.tax_type == 1) {
      this.totalTax = Tax;
    }

    console.log('TAI',this.totalTax )
    this.totalBill = this.totalLines + this.totalTax;
    console.log('his.generaLines',this.generaLines, this. totalLines )
    console.log('his.totalLineas',totalLineas)
    this.ratioDSCTO =    Number(totalLineas/this.generaLines).toFixed(10);
console.log('ratioDSCTO',this.ratioDSCTO)
    this.updateDiscount();

  }

  updateTax() {
    // tslint:disable-next-line:triple-equals
    if (this.tax_type == 1) {
      this.totalTax = (this.totalLines * this.IGV);
    } else {
      this.totalTax = 0;
    }
    this.totalBill = this.totalLines + this.totalTax;
  }

  ngOnInit() {
  }

  createBill(billingForm: NgForm) {
    if (billingForm.valid) {
      /*this.notifierService.systemNotify({
        title: 'Espere',
        message: 'Generando Factura',
        duration: 8000,
        type: 'info'
      });*/
      const listProducts: any = [];
      const discountsAplied: any = [];
      
      for (let index = 0; index < this.budgetDetailData.length; index++) {
        const detailProd: any = this.budgetDetailData[index];
        if (detailProd.selected) {
          // tslint:disable-next-line:triple-equals
          if (this.tax_type == 1) {
            detailProd.impuesto_amount = (this.IGV * this.totalDescAmount[index]);
          }
          detailProd.subtotal = this.totalDescAmount[index].toFixed(2);
          detailProd.total_amount = this.totalDescAmount[index].toFixed(2);
          detailProd.codigo_sunat = this.codigo_sunat[index];
          detailProd.tipoImpuesto = this.tax_type;
          detailProd.price = detailProd.price * this.percentageAmount[index] / 100
          detailProd.price_full = detailProd.price_full * this.percentageAmount[index] / 100
          detailProd.price_total = detailProd.price_total * this.percentageAmount[index] / 100

          listProducts.push(detailProd);
          this.discounts.forEach((item)=>{
            if(item.lineSelect == index){
              discountsAplied.push(item);
            }
          })
        }
      }
      const clientData: any = {
        id: this.budgetHeaderData.client_id,
        companyName: this.budgetHeaderData.client_name,
        direction: this.budgetHeaderData.client_address,
        doc_num: this.budgetHeaderData.client_doc_num,
        doc_type: this.budgetHeaderData.client_doc_type,
      };

      var dsctGlobal = this.totalDiscount ?this.totalDiscount:0;
      
      const listBody: any = {
        id_client: this.budgetHeaderData.client_id,
        client_address: this.budgetHeaderData.client_address,
        client_doc_num: this.budgetHeaderData.client_doc_num,
        client_doc_type: this.budgetHeaderData.client_doc_type,
        client_email: this.budgetHeaderData.client_email,
        money: this.currencyMoney,
        clientData: clientData,
        detail: listProducts,
        discounts: discountsAplied,
        tipo: this.typeBilling,
        id_factura_emitida: this.billId,
        nota_credito: this.typeNoteCreditPronos,
        nota_debito: this.typeNoteDebitPronos,
        discount_global :dsctGlobal
      };
      if (listProducts.length > 0) {
        let pendDiscounts=0;

        listProducts.forEach((item,_index)=>{
          if(item.total_amount < 0 ){
            pendDiscounts=pendDiscounts+(-1)*item.total_amount
          }
        })

        if(this.totalLines>pendDiscounts){
          if(pendDiscounts>0){
            this.assignDiscount(listProducts,pendDiscounts);
            console.log("body",listBody,"header",this.budgetHeaderData)
          }else{
            let newList=[]
            
            for (let index = 0; index < this.budgetDetailData.length; index++) {
              const detailProd: any = this.budgetDetailData[index];
              if (detailProd.selected && detailProd.price >= 0) {
                // tslint:disable-next-line:triple-equals
                if (this.tax_type == 1) {
                  detailProd.impuesto_amount = (this.IGV * this.totalDescAmount[index] ) ;
                  

                }

                detailProd.subtotal = this.totalDescAmount[index].toFixed(2);
                detailProd.codigo_sunat = this.codigo_sunat[index];
                detailProd.discount = ( this.appliedDiscount[index]).toFixed(2);


                

                detailProd.total_amount = this.totalDescAmount[index].toFixed(2);
                detailProd.tipoImpuesto = this.tax_type;
                newList.push(detailProd);
              }
            }

            listBody.detail=newList;

            console.log("body",listBody,"header",this.budgetHeaderData)

            this.internalService.internalNotify({ show: true, pronosBill: listBody, budgetHeader: this.budgetHeaderData });
          }
        } else {

          this.notifierService.systemNotify({
            title: 'Error',
            message: 'El descuento es mayor al total',
            type: 'error',
            duration: 5000
          });
        }
      } else {

        this.notifierService.systemNotify({
          title: 'Error',
          message: 'No se han seleccionado la informacion necesaria.',
          type: 'error',
          duration: 5000
        });
      }
    } else {
      this.notifierService.systemNotify({
        title: 'Error',
        message: 'No se han seleccionado la informacion necesaria.',
        type: 'error',
        duration: 5000
      });
    }
  }

  validateDiscount(i,val,type){
    console.log('Vadksi',i, val, type)
    if (type == 1) {
      if((this.totalDescAmount[i] - ((val / 100) * this.totalAmount[i])) >= 0){
        return true;
      }else{
        this.notifierService.systemNotify({
          title: 'Error',
          message: 'No se puede aplicar este descuento a la linea seleccionada',
          type: 'error',
          duration: 5000
        });
        return false;
      }
    } else if (type == 2){
      console.log(this.totalDescAmount);
      if((this.totalDescAmount[i]-val) >= 0){
        return true;
      }else{
        this.notifierService.systemNotify({
          title: 'Error',
          message: 'No se puede aplicar este descuento a la linea seleccionada',
          type: 'error',
          duration: 5000
        });
        return false;
      }
    }
    return false;
  }

  assignDiscount(listProducts,pendDiscounts){
    

    if(pendDiscounts>0){
      this.linesDiscount = []
      //let negativeLines = []
      for (let index = 0; index < this.budgetDetailData.length; index++) {
        const detailProd: any = this.budgetDetailData[index];
        if (detailProd.selected && detailProd.price) {
          if(detailProd.price>0){
            this.linesDiscount.push({description: detailProd.description, line: index});
          }
        }
      }

      const dialogRef = this.dialog.open(AssignDiscountModalComponent, {
        data: {lines: this.linesDiscount,discount:pendDiscounts},
      });
    
      dialogRef.afterClosed().subscribe(result => {
        this.appService
        .fetchData(result)
        .subscribe((res: any) => {
          if(res!=undefined && this.validateDiscount(res.lineSelect, res.value, res.type)){
            this.discounts.push(res);
            this.updateDiscount();
          }
        });
      });
    }
  }

  addDiscount(){
    this.linesDiscount = []
    let anySelected = false;
    for (let index = 0; index < this.budgetDetailData.length; index++) {
      const detailProd: any = this.budgetDetailData[index];
      if (detailProd.selected) {
        this.linesDiscount.push({description: detailProd.description, line: index});
        anySelected = true;
      }
    }

    if(anySelected){
      const dialogRef = this.dialog.open(DiscountModalComponent, {
        data: this.linesDiscount,
      });

      dialogRef.afterClosed().subscribe(result => {
        this.appService
        .fetchData(result)
        .subscribe((res: any) => {
          if(res!=undefined && this.validateDiscount(res.lineSelect, res.value, res.type)){
            this.discounts.push(res);
            this.updateDiscount();
          }
        });
      });
    }else{
      this.notifierService.systemNotify({
        title: 'Error',
        message: 'Debe seleccionar algun detalle de pago',
        type: 'error',
        duration: 5000
      });
    }
  }
  addGlobalDiscount(descuento){
this.updateDiscount();
  }


  removediscount(index: number): void {
    this.discounts.splice(index, 1);
    this.updateDiscount();
  }

  updateDiscount(){
    this.totalDiscount = 0;
    var localDiscounGlobal = this.budgetHeaderData.discount_global?this.budgetHeaderData.discount_global:0;
    
    this.totalDiscount += localDiscounGlobal*this.ratioDSCTO;
    console.log('totalDiscount',this.totalDiscount, this.ratioDSCTO, localDiscounGlobal)
    console.log('appliedDiscount',this.appliedDiscount)
    this.appliedDiscount.forEach((item) => {

      this.totalDiscount = this.totalDiscount + item;


    })


/* DESCATIVADO YA QUE POR REGLA LOS PRESUPUESTOS SON FINALES Y NO RECIBEN MAS DESCUENTOS
    this.totalDiscount = 0;
    this.totalDiscount += this.budgetHeaderData.discount_global?this.budgetHeaderData.discount_global:0;
    this.totalAmount.forEach((item, _index) => {
      this.totalDescAmount[_index] = item;
    })

    this.discounts.forEach((item) => {
      if(item.type == 1){
        this.totalDescAmount[item.lineSelect] -= (item.value / 100) * (this.totalAmount[item.lineSelect]);
        this.totalDiscount = this.totalDiscount + (item.value / 100) * (this.totalAmount[item.lineSelect]);
      } else {
        this.totalDescAmount[item.lineSelect] -= (item.value);
        this.totalDiscount = this.totalDiscount + item.value;
      }

      if(item.assigned){
        let descPend = item.value;
        for (let index = 0; index < this.budgetDetailData.length; index++) {
          const detailProd: any = this.budgetDetailData[index];
          if (detailProd.selected && detailProd.price<0 && descPend>0) {
            if((-1)*(this.totalDescAmount[index])>descPend){
              this.totalDescAmount[index]+= (descPend);
              descPend=0;
            }else{
              descPend = descPend + this.totalDescAmount[index];
              this.totalDescAmount[index] = 0;
            }
          }
        }
      }
    });
*/
      /*
      negativeLines.forEach((item)=>{
        if((-1)*(item.index) < res.value){
          item.total_amount = 0
          res.value += res.value - item.total_amount
        }else{
          item.total_amount += res.value
        }  
      })
      */

    this.totalTax=0

    if (this.tax_type == 1) {

      let Tax = 0;
      this.totalAmount.forEach((item, _index) => {
       // if(item>=0)
       //   this.totalLines += item;
          Tax += Number((item*this.IGV).toFixed(2))
  
          console.log('OTEMS', item, Tax)
      });
      this.totalTax  = Tax;
      this.totalTax -=   this.totalDiscount?this.totalDiscount*this.IGV:0;
/*  
      this.totalDescAmount.forEach(i=>{
        this.totalTax += Number((i*this.IGV).toFixed(2))
      })
      this.totalTax -=   this.totalDiscount?this.totalDiscount*this.IGV:0;*/
    }
    //console.log(this.totalTax);
    this.totalBill = this.totalLines + this.totalTax - this.totalDiscount;
    //this.totalBill = this.totalLines + this.totalTax - this.totalDiscount;
  }

  onDomChange($event: Event): void {
    console.log($event);
  }
}



// WEBPACK FOOTER //
// ./src/app/system/billing/new-billing/new-billing.component.ts